module.exports = __webpack_public_path__ + "img/bgPros.9834dc61.png";